import React from 'react';
import RutaCard from './RutaCard';

const RutasSection = () => {
    const rutas = [
    {
      id: 1,
      title: "Ruta Especialista Tech",
      description: "Formación en tecnologías emergentes, programación, análisis de datos y habilidades digitales del futuro.",
      icon: "💻",
      color: "from-red-500 to-red-700",
      skills: ["Fábrica de Desarrolladores", "Laboratorio de IA y Cloud Computing", "Soluciones de Futuro con IA y Datos"]
    },
    {
      id: 2,
      title: "Ruta Jóvenes con Oportunidades",
      description: "Programas diseñados para jóvenes que buscan su primera experiencia laboral y desarrollo profesional.",
      icon: "🚀",
      color: "from-orange-500 to-red-600",
      skills: ["Soporte técnico en sistemas", "Analista de sistemas informáticos", "Gestión de mesa de servicio", "Marketing Digital - Community Manager"]
    }
  ];

return (
    <section id="rutas" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Encabezado */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {rutas.map((ruta, index) => (
            <div key={ruta.id} className="h-full">
              <RutaCard ruta={ruta} index={index} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RutasSection;